<a-payment-required [message]="message"></a-payment-required>